import * as types from "./routeMasterActionType";
const initialState = {
  routeList: [],
  cityList: [],
  classTypeList: [],
  routeLegsList: [],
  addedRoute: {},
  routeLegsDetails: [],
  levyTypeList: [],
};
const routeMasterReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ROUTE_LIST:
      return { ...state, routeList: action.data };
    case types.CITY_LIST:
      return { ...state, cityList: action.data };

    case types.CLASS_TYPE_LIST_ROUTE:
      return { ...state, classTypeList: action.data };

    case types.LEVY_TYPE_LIST:
      return { ...state, levyTypeList: action.data };
    case types.UPDATE_ROUTE:
      return { ...state, addedRoute: action.data };
    case types.ROUTE_LEGS_LIST:
      return { ...state, routeLegsList: action.data };
    case types.ROUTE_LIST_DETAILS:
      return { ...state, routeLegsDetails: action.data };

    default:
      return state;
  }
};
export default routeMasterReducer;
